import { useState } from 'react';
import {
  Dimensions,
  Modal,
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
} from 'react-native';
import { Colors } from '../../../themes/colors';
import { AlertList } from './alertList';

type AlertListModalProps = {
  alertListModalVisible: boolean;
  alertListModalStyle: StyleProp<ViewStyle>;
  onClose: () => void;
  routineId: string;
  workspaceAssetId: string;
  closeNewAlertModal: () => void;
  closeEditAlertModal: () => void;
  showNewAlertModal: () => void;
  newAlertModalVisible: boolean;
  closeAlertListModal: () => void;
  hideAlertListModal: () => void;
  productId?: string;
};

export const AlertListModal = ({
  alertListModalVisible,
  alertListModalStyle,
  onClose,
  routineId,
  workspaceAssetId,
  closeNewAlertModal,
  closeEditAlertModal,
  showNewAlertModal,
  newAlertModalVisible,
  closeAlertListModal,
  hideAlertListModal,
  productId,
}: AlertListModalProps) => {
  const [editAlertModalVisible, setEditAlertModalVisible] = useState(false);
  const [editAlertModalStyle, setEditAlertModalStyle] = useState<
    StyleProp<ViewStyle>
  >(styles.hidden);

  const handleShowNewAlertModal = () => {
    showNewAlertModal();
    closeAlertListModal();
  };

  const handleCloseNewAlertModal = () => {
    closeNewAlertModal();
  };

  const handleShowEditAlertModal = () => {
    hideAlertListModal();
    setEditAlertModalVisible(true);
    setEditAlertModalStyle(styles.webModalBackground);
  };

  const handleCloseEditAlertModal = () => {
    setEditAlertModalVisible(false);
    closeEditAlertModal();
  };

  return (
    <Modal
      visible={alertListModalVisible}
      transparent={true}
      onRequestClose={onClose}
    >
      <View style={alertListModalStyle}>
        <View style={styles.modalContainer}>
          <AlertList
            onClose={onClose}
            workspaceAssetId={workspaceAssetId}
            routineId={routineId}
            newAlertModalVisible={newAlertModalVisible}
            editAlertModalVisible={editAlertModalVisible}
            editAlertModalStyle={editAlertModalStyle}
            handleCloseNewAlertModal={handleCloseNewAlertModal}
            handleShowNewAlertModal={handleShowNewAlertModal}
            handleShowEditAlertModal={handleShowEditAlertModal}
            handleCloseEditAlertModal={handleCloseEditAlertModal}
            productId={productId}
          />
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  webModalBackground: {
    flex: 1,
    backgroundColor: Colors.role.inverseDim,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    width: '100%',
    maxWidth: 560,
    minHeight: 461,
    maxHeight: Dimensions.get('window').height * 0.65,
    backgroundColor: Colors.role.surfaceHover,
    borderRadius: 12,
    overflow: 'hidden',
    elevation: 10,
  },
  hidden: {
    height: 0,
    width: 0,
    maxHeight: 0,
    minHeight: 0,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
